import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import App from './App';
import './styles/global.css';

import { ColorModeContext } from './ColorModeContext';
import { buildTheme } from './theme';

function getInitialMode() {
  const saved = (localStorage.getItem('theme') || 'light').toLowerCase();
  return saved === 'dark' ? 'dark' : 'light';
}

function Root() {
  const [mode, setMode] = React.useState(getInitialMode);

  // Keep legacy CSS theme variables in sync (global.css uses body.dark)
  React.useEffect(() => {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(mode);
    localStorage.setItem('theme', mode);
  }, [mode]);

  const toggle = React.useCallback(() => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  const ctxValue = React.useMemo(
    () => ({
      mode,
      toggle,
      setMode: (m) => setMode(m === 'dark' ? 'dark' : 'light'),
    }),
    [mode, toggle]
  );

  const theme = React.useMemo(() => buildTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={ctxValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
